export default {
  'pages.layouts.userLayout.title':
    'Go-admin is the most influential web design specification in Xihu district',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage': 'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username: admin',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password: 123456',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage': 'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
  'pages.searchUser.titleOption': '操作',
  'pages.searchUser.title': '用户管理',
  'pages.searchUser.update': '编辑',
  'pages.searchUser.userId': '编码',
  'pages.searchUser.username': '用户名',
  'pages.searchUser.nickName': '昵称',
  'pages.searchUser.phone': '手机',
  'pages.searchUser.deptName': 'deptName',
  'pages.searchUser.createForm.newUser': '新用户',
  'pages.searchUser.updateForm.updateUser': '编辑用户信息',
  'pages.searchTable.updateForm.roleId.nameLabel': '角色',
  'pages.searchTable.updateForm.deptId.nameLabel': '部门',
  'pages.searchTable.updateForm.phone.nameLabel': '手机号',
  'pages.searchTable.updateForm.nickName.nameLabel': '昵称',
  'pages.searchTable.updateForm.post.nameLabel': '职位',
  'pages.searchTable.updateForm.status.nameLabel': '状态',
  'pages.searchTable.updateForm.sexType.nameLabel': '性别',
  'pages.searchTable.updateForm.username.nameLabel': '用户名',
  'pages.searchTable.updateForm.email.nameLabel': '电子邮箱',
  'pages.searchTable.updateForm.remark.nameLabel': '备注',
  'pages.searchTable.updateForm.roleId.nameRules': '请输入角色',
  'pages.searchTable.updateForm.deptId.nameRules': '请输入部门',
  'pages.searchTable.updateForm.phone.nameRules': '请输入手机号',
  'pages.searchTable.updateForm.nickName.nameRules': '请输入昵称',
  'pages.searchTable.updateForm.post.nameRules': '请选择职位',
  'pages.searchTable.updateForm.status.nameRules': '请选择状态',
  'pages.searchTable.updateForm.sexType.nameRules': '请选择性别',
  'pages.searchTable.updateForm.username.nameRules': '请输入用户名',
  'pages.searchTable.updateForm.email.nameRules': '请输入电子邮箱',
  'pages.searchUser.newUser': '新用户',
  'pages.searchUser.batchApproval': '批量',
  'pages.searchUser.batchDeletion': '批量删除',
  'pages.searchUser.resetPwassword': 'reset',
  'pages.searchUser.resetPasswordForm.resetPassword': 'Reset Password',
  'pages.searchTable.resetPasswordForm.password.nameRules': 'Password',

  // Time Token Management Related
  'pages.timeToken.title': 'Time Token Management',
  'pages.timeToken.description': 'Manage all time tokens in the system, including viewing status, revoking tokens, and quota monitoring.',
  'pages.timeToken.device': 'Device Info',
  'pages.timeToken.license': 'License',
  'pages.timeToken.hash': 'Token Hash',
  'pages.timeToken.usage': 'Usage Count',
  'pages.timeToken.stats.title': 'Statistics Panel',
  'pages.timeToken.list.title': 'Token List',
  'pages.timeToken.usage.title': 'Usage Statistics',
  'pages.timeToken.analysis.title': 'Advanced Analysis',
  'pages.timeToken.id': 'Token ID',
  'pages.timeToken.name': 'Token Name',
  'pages.timeToken.user': 'Assigned User',
  'pages.timeToken.status': 'Status',
  'pages.timeToken.quota': 'Quota',
  'pages.timeToken.used': 'Used',
  'pages.timeToken.remaining': 'Remaining',
  'pages.timeToken.expires': 'Expires At',
  'pages.timeToken.createdAt': 'Created At',
  'pages.timeToken.updatedAt': 'Updated At',
  'pages.timeToken.action.adjust': 'Adjust Quota',
  'pages.timeToken.action.view': 'View Details',
  'pages.timeToken.action.revoke': 'Revoke Token',
  'pages.timeToken.action.delete': 'Delete Token',
  'pages.timeToken.action.enable': 'Enable',
  'pages.timeToken.action.disable': 'Disable',
  'pages.timeToken.status.active': 'Active',
  'pages.timeToken.status.inactive': 'Inactive',
  'pages.timeToken.status.expired': 'Expired',
  'pages.timeToken.status.suspended': 'Suspended',
  'pages.timeToken.modal.adjustQuota.title': 'Adjust Quota',
  'pages.timeToken.modal.adjustQuota.reason': 'Adjustment Reason',
  'pages.timeToken.modal.adjustQuota.reason.placeholder': 'Please enter adjustment reason',
  'pages.timeToken.modal.adjustQuota.newQuota': 'New Quota',
  'pages.timeToken.modal.adjustQuota.newQuota.placeholder': 'Please enter new quota value',
  'pages.timeToken.modal.adjustQuota.submit': 'Confirm Adjustment',
  'pages.timeToken.modal.adjustQuota.cancel': 'Cancel',
  'pages.timeToken.usage.chart.daily': 'Daily Usage',
  'pages.timeToken.usage.chart.trend': 'Usage Trend',
  'pages.timeToken.usage.chart.distribution': 'Usage Distribution',
  'pages.timeToken.usage.summary.total': 'Total',
  'pages.timeToken.usage.summary.active': 'Active',
  'pages.timeToken.usage.summary.expired': 'Expired',
  'pages.timeToken.usage.summary.suspended': 'Suspended',
  'pages.timeToken.analysis.efficiency.title': 'Efficiency Analysis',
  'pages.timeToken.analysis.efficiency.score': 'Efficiency Score',
  'pages.timeToken.analysis.efficiency.rank': 'Efficiency Rank',
  'pages.timeToken.analysis.anomaly.title': 'Anomaly Detection',
  'pages.timeToken.analysis.anomaly.type': 'Anomaly Type',
  'pages.timeToken.analysis.anomaly.description': 'Anomaly Description',
  'pages.timeToken.analysis.optimization.title': 'Optimization Suggestions',
  'pages.timeToken.analysis.optimization.suggestion': 'Suggestion',
  'pages.timeToken.analysis.optimization.impact': 'Expected Impact',
  'pages.timeToken.analysis.underused.title': 'Underused Tokens',
  'pages.timeToken.analysis.highperformance.title': 'High Performance Tokens',
  'pages.timeToken.analysis.bestpractice': 'Best Practice',
};
